import React from 'react'

function Medical() {
  return (
    <div>Medical</div>
  )
}

export default Medical